import { DeviceMetadata } from './types'

// outlives logout on purpose: flipper keys the authenticated device on this id,
// so logging in again from the same browser reactivates the same device
// instead of spending one of the two device slots
const DEVICE_ID_KEY = 'auth-device-id'

const getDeviceId = () => {
  const stored = localStorage.getItem(DEVICE_ID_KEY)
  if (stored) {
    return stored
  }

  const deviceId = crypto.randomUUID()
  localStorage.setItem(DEVICE_ID_KEY, deviceId)
  return deviceId
}

// order matters: Edge and Opera also carry "Chrome", and Chrome carries "Safari"
const browsers: [RegExp, string][] = [
  [/Edg\//, 'Edge'],
  [/OPR\//, 'Opera'],
  [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'],
  [/Safari\//, 'Safari']
]

// Android also says Linux, as do the few browsers that name their
// distribution, so the specific systems come first
const systems: [RegExp, string][] = [
  [/iPhone|iPad/, 'iOS'],
  [/Android/, 'Android'],
  [/Windows/, 'Windows'],
  [/Mac OS X|Macintosh/, 'macOS'],
  [/CrOS/, 'ChromeOS'],
  [/Ubuntu/, 'Ubuntu'],
  [/Fedora/, 'Fedora'],
  [/Linux/, 'Linux']
]

const match = (list: [RegExp, string][], userAgent: string) =>
  list.find(([pattern]) => pattern.test(userAgent))?.[1]

// the label the professional sees in the device list, e.g. "Chrome on macOS"
const getDeviceName = () => {
  const userAgent = navigator.userAgent
  const browser = match(browsers, userAgent) ?? 'Browser'
  const system = match(systems, userAgent)
  return system ? `${browser} on ${system}` : browser
}

export const getDeviceMetadata = (): DeviceMetadata => ({
  device_id: getDeviceId(),
  device_name: getDeviceName(),
  device_platform: 'web'
})
